import { Helmet } from 'react-helmet-async';

const videos = [
  {
    title: "Blackmagic Films Demo Reel",
    url: "https://youtu.be/fLh199VEu3c",
    featured: true,
    date: "2024-03-01",
    description: "Full cinematic demo reel by Blackmagic Films showcasing music videos, brand content, and artist sessions shot on Blackmagic Cinema Camera 6K across New Jersey, Pennsylvania, and New York City.",
  },
  {
    title: "Bronco Brew — Full Release",
    url: "https://youtu.be/mGQaJwwUXSk",
    cover: "/images/covers/fordfrontsight.png",
    date: "2023-08-15",
    description: "Full-length commercial video for Bronco Brew, produced by Blackmagic Films in 6K cinematic quality.",
  },
  {
    title: "Bronco Brew — Teaser",
    url: "https://youtu.be/ZY687dUB_7o",
    cover: "/images/covers/broncobrew.png",
    date: "2023-07-01",
    description: "Teaser trailer for Bronco Brew brand video, produced by Blackmagic Films.",
  },
  {
    title: "Front Sight Coffee: Origins",
    url: "https://youtu.be/OJaoyYkwgQQ",
    date: "2023-09-01",
    description: "Brand documentary for Front Sight Coffee — a cinematic origin story produced by Blackmagic Films.",
  },
  {
    title: "Pool Scum",
    url: "https://youtu.be/fLiJwl54zok",
    cover: "/images/covers/poolscum.png",
    date: "2022-11-01",
    description: "Music video for Pool Scum, directed and produced by Blackmagic Films. Shot handheld with vintage glass and a moody cinematic grade.",
  },
  {
    title: "Jersey Joint Dispensary — Jim Belushi",
    url: "https://youtu.be/5GRI1_MDY4w",
    cover: "/images/covers/jimbelushi.png",
    date: "2023-10-01",
    description: "Brand promo video featuring actor Jim Belushi for Jersey Joint Dispensary, produced by Blackmagic Films in New Jersey.",
  },
  {
    title: "420 Fest — Jersey Joint Dispensary",
    url: "https://youtu.be/unNDwilLvF4",
    cover: "/images/covers/420fest.png",
    date: "2026-04-20",
    description: "Full event coverage of Jersey Joint Dispensary's 420 Fest in New Jersey — capturing performances, crowd energy, and atmosphere, produced by Blackmagic Films.",
  },
  {
    title: "GWAR — The Secret Stash Promo",
    url: "https://youtu.be/63-anjYLujQ",
    date: "2026-03-01",
    description: "On-location promo video capturing GWAR's appearance at Kevin Smith's The Secret Stash comic book shop in Red Bank, NJ — produced by Blackmagic Films.",
  },
  {
    title: "MJ Unpacked X Jersey Joint",
    url: "https://youtube.com/shorts/UgUN02dsRms",
    cover: "/images/covers/mjunpacked-jerseyjoint.png",
    short: false,
    date: "2024-06-01",
    description: "Short-form brand content for MJ Unpacked x Jersey Joint Dispensary, produced by Blackmagic Films.",
  },
  {
    title: "The Secret Stash",
    url: "https://youtu.be/YvVbA3wJDck",
    cover: "/images/covers/thesecretstash.png",
    date: "2026-04-01",
    description: "On-location cinematic coverage of Kevin Smith's The Secret Stash comic book shop in Red Bank, NJ — produced by Blackmagic Films.",
  },
  {
    title: "Niche Commercial",
    url: "https://youtube.com/shorts/Rx8dYuSoFCk",
    cover: "/images/covers/nichecommercial.png",
    date: "2026-07-11",
    description: "Niche commercial short-form footage produced by Blackmagic Films.",
  },
  {
    title: "Jersey Joint: 710 Holiday",
    url: "https://youtube.com/shorts/bGW3e6grUNw",
    cover: "/images/covers/jerseyjoint-710.png",
    date: "2026-07-11",
    description: "Short-form footage from Jersey Joint Dispensary's 710 Holiday celebration, produced by Blackmagic Films.",
  },
  {
    title: "Kevin Smith: Tusk",
    url: "https://youtube.com/shorts/ui8j_jh_APk",
    cover: "/images/covers/kevinsmith-tusk.png",
    date: "2026-07-11",
    description: "Short-form footage with Kevin Smith discussing Tusk, captured at The Secret Stash by Blackmagic Films.",
  },
  {
    title: "Kevin Smith: The Best Advice?",
    url: "https://youtube.com/shorts/-KMyrfp1Qt0",
    cover: "/images/covers/kevinsmith-bestadvice.png",
    date: "2026-07-11",
    description: "Short-form clip of Kevin Smith sharing his best advice, captured at The Secret Stash by Blackmagic Films.",
  },
];

function getVideoId(url) {
  if (url.includes("/shorts/")) return url.split("/shorts/")[1].split("?")[0];
  return url.split("youtu.be/")[1]?.split("?")[0];
}

const videoSchema = {
  "@context": "https://schema.org",
  "@graph": videos.map((v) => {
    const id = getVideoId(v.url);
    return {
      "@type": "VideoObject",
      "name": v.title,
      "description": v.description,
      "thumbnailUrl": `https://img.youtube.com/vi/${id}/maxresdefault.jpg`,
      "uploadDate": v.date,
      "embedUrl": `https://www.youtube.com/embed/${id}`,
      "url": v.url,
      "publisher": {
        "@id": "https://www.blackmagicfilms.com/#organization"
      }
    };
  }),
};

function PlayIcon() {
  return (
    <svg
      viewBox="0 0 64 64"
      className="w-14 h-14 drop-shadow-lg"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="32" fill="rgba(0,0,0,0.55)" />
      <polygon points="26,20 48,32 26,44" fill="white" />
    </svg>
  );
}

function FeaturedCard({ title, url, cover }) {
  const videoId = getVideoId(url);
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative block w-full overflow-hidden rounded-2xl ring-1 ring-white/10 bg-neutral-900"
    >
      <img
        src={cover || `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
        alt={title}
        className="w-full aspect-video object-cover transition-transform duration-500 group-hover:scale-105"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <PlayIcon />
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-6">
        <span className="text-xs tracking-[0.25em] uppercase text-amber-400 font-medium">
          Featured
        </span>
        <h2 className="text-2xl sm:text-3xl font-black mt-1 text-white leading-tight">
          {title}
        </h2>
      </div>
    </a>
  );
}

function VideoCard({ title, url, cover, short }) {
  const videoId = getVideoId(url);
  const isShort = url.includes("/shorts/") && short !== false;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative block overflow-hidden rounded-xl ring-1 ring-white/10 bg-neutral-900 hover:ring-white/30 transition-all duration-300"
    >
      <div className="relative overflow-hidden">
        <img
          src={cover || `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
          alt={title}
          className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${isShort ? "aspect-[9/16]" : "aspect-video"}`}
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <PlayIcon />
        </div>
      </div>
      <div className="px-4 py-3">
        <p className="text-sm font-semibold text-white/90 group-hover:text-white transition-colors leading-snug">
          {title}
        </p>
        <p className="text-xs text-white/40 mt-0.5">YouTube ↗</p>
      </div>
    </a>
  );
}

export default function Reel() {
  const featured = videos.find((v) => v.featured);
  const isShortVideo = (v) => v.url.includes("/shorts/") && v.short !== false;
  const mainVideos = videos.filter((v) => !v.featured && !isShortVideo(v));
  const shorts = videos.filter((v) => isShortVideo(v));

  return (
    <>
    <Helmet>
      <title>Video Production Reel | Blackmagic Films — 6K Cinematic | NJ, PA & NYC</title>
      <meta name="description" content="Watch Blackmagic Films' cinematic production reel. Music videos, brand films, and artist sessions shot in 6K on Blackmagic Cinema Cameras across New Jersey, Philadelphia, and NYC." />
      <link rel="canonical" href="https://www.blackmagicfilms.com/reel" />
      <meta property="og:title" content="Video Production Reel | Blackmagic Films — 6K Cinematic" />
      <meta property="og:description" content="6K cinematic production reel — music videos, brand films, and artist sessions across NJ, PA, and NYC." />
      <meta property="og:url" content="https://www.blackmagicfilms.com/reel" />
      <meta property="og:image" content="https://www.blackmagicfilms.com/images/og-image.jpg" />
      <script type="application/ld+json">{JSON.stringify(videoSchema)}</script>
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.blackmagicfilms.com/" },
          { "@type": "ListItem", "position": 2, "name": "Selected Works", "item": "https://www.blackmagicfilms.com/reel" }
        ]
      })}</script>
    </Helmet>
    <div className="min-h-screen bg-black text-white pt-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-10 py-10 md:py-16">

        {/* Header */}
        <div className="mb-10">
          <span className="text-xs tracking-[0.3em] uppercase text-amber-400 font-medium">
            Portfolio
          </span>
          <h1 className="text-4xl sm:text-5xl font-black mt-1">Selected Works</h1>
          <p className="mt-3 text-white/50 max-w-xl">
            Music videos, brand films, and commercial work — shot on Blackmagic Cinema.
          </p>
        </div>

        {/* Featured */}
        {featured && (
          <div className="mb-10">
            <FeaturedCard {...featured} />
          </div>
        )}

        {/* Divider */}
        <div className="flex items-center gap-4 mb-8">
          <span className="text-xs tracking-[0.25em] uppercase text-white/40 font-medium">
            More Work
          </span>
          <div className="flex-1 h-px bg-white/10" />
        </div>

        {/* Main Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mainVideos.map((video) => (
            <VideoCard key={video.url} {...video} />
          ))}
        </div>

        {/* Social Media Shorts */}
        {shorts.length > 0 && (
          <div className="mt-16">
            <div className="flex items-center gap-4 mb-8">
              <span className="text-xs tracking-[0.25em] uppercase text-white/40 font-medium">
                Social Media Shorts
              </span>
              <div className="flex-1 h-px bg-white/10" />
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
              {shorts.map((video) => (
                <VideoCard key={video.url} {...video} />
              ))}
            </div>
          </div>
        )}

      </div>
    </div>
    </>
  );
}
